import { Link } from "react-router";

interface BreadcrumbProps {
	readonly sectionTitle: string;
	readonly links: BreadcrumbLink[];
}
export function Breadcrumb(props: BreadcrumbProps) {
	return (
		<div className="row">
			<div className="col-lg-12">
				<div className="page-header" style={{ display: "flex" }}>
					<div style={{ width: "50%", float: "left" }}>
						<h2>{props.sectionTitle}</h2>
						<ol className="breadcrumb">
							{props.links.map((link) => (
								<BreadcrumbItem key={link.label} link={link} />
							))}
						</ol>
					</div>
				</div>
			</div>
		</div>
	);
}
function BreadcrumbItem(props: { readonly link: BreadcrumbLink; }) {
	const link = props.link;
	if (link.active)
		return (
			<li className='active'>
				{link.label}
			</li>
		);
	else
		return (
			<li>
				<Link to={link.to}>{link.label}</Link>
			</li>
		);
}

type BreadcrumbLink = { label: string; to: string; active?: undefined; } | { label: string; active: true; to?: undefined; };